import type { ReactElement } from "react";

import { useDispatch, useSelector } from "react-redux";

import type { BaseActivatedPanelProps } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import { selectActiveLeadsType, selectActiveSearchResultsDto } from "app/pages/sales-intelligence/modules/leads-search";
import { useListParams } from "app/pages/sales-intelligence/modules/lists/context/ListParamsContext";
import { exportTopNLeadsToHsThunk } from "app/pages/sales-intelligence/pages/opportunity-list/store/effects";
import { exportDomainsToHsThunk } from "app/pages/sales-intelligence/sub-modules/management/store/effects/hubspot/export";
import { selectHsExportingTo } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/hubspot/exportSelectors";

import CrmExportPanelContainer from "./CrmExportPanelContainer";

const HubSpotExportPanelContainer = (props: BaseActivatedPanelProps): ReactElement => {
    const dispatch = useDispatch();

    const exportIsInProgress = useSelector(selectHsExportingTo);
    const activeLeadsType = useSelector(selectActiveLeadsType);
    const searchResultsDto = useSelector(selectActiveSearchResultsDto);

    const listParams = useListParams();

    const handleExportNDomains = (domainsCount: number, countries: readonly number[]) => {
        void dispatch(
            exportTopNLeadsToHsThunk({
                domainsCount,
                countries,
                leadsType: activeLeadsType,
                dto: searchResultsDto,
                listParams,
            }),
        );
    };

    const handleExportDomains = (domains: readonly string[], countries: readonly number[]) => {
        void dispatch(exportDomainsToHsThunk(domains, countries, activeLeadsType, listParams.id));
    };

    return (
        <CrmExportPanelContainer
            integration="hubspot"
            isExportInProgress={exportIsInProgress}
            label={{ key: "si.multi_selector.hubspot.title" }}
            onDeactivate={props.onDeactivate}
            onExportNDomains={handleExportNDomains}
            onExportDomains={handleExportDomains}
        />
    );
};

export default HubSpotExportPanelContainer;
